import React from 'react';
import CommentInline from './CommentInline';

export default function Comment(props: React.ComponentProps<typeof CommentInline>) {
    return <CommentInline {...props}/>;
}
